import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import PlaceDetail from "@/pages/PlaceDetail";
import CityDetail from "@/pages/CityDetail";
import TrailPage from "@/pages/TrailPage";
import VenueDetail from "@/pages/VenueDetail";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import Genres from "@/pages/Genres";
import GenreDetail from "@/pages/GenreDetail";
import Instruments from "@/pages/Instruments";
import InstrumentDetail from "@/pages/InstrumentDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Charts from "@/pages/Charts";
import News from "@/pages/News";
import Community from "@/pages/Community";
import HallOfFame from "@/pages/HallOfFame";
import SearchPage from "@/pages/SearchPage";
import SocialPulseCallback from "@/pages/SocialPulseCallback";
import Moderation from "@/pages/Moderation";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-[#FAFAFC]">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/countries" element={<Navigate to="/explore" replace />} />
            <Route path="/places/:slug" element={<PlaceDetail />} />
            <Route path="/places/:slug/cities/:citySlug" element={<CityDetail />} />
            <Route path="/places/:slug/cities/:citySlug/trail" element={<TrailPage />} />
            <Route path="/venues/:venueId" element={<VenueDetail />} />
            <Route path="/artists" element={<Artists />} />
            <Route path="/artists/:slug" element={<ArtistDetail />} />
            <Route path="/genres" element={<Genres />} />
            <Route path="/genres/:slug" element={<GenreDetail />} />
            <Route path="/instruments" element={<Instruments />} />
            <Route path="/instruments/:slug" element={<InstrumentDetail />} />
            <Route path="/learn" element={<Navigate to="/instruments" replace />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:eventSlug" element={<EventDetail />} />
            <Route path="/charts" element={<Charts />} />
            <Route path="/news" element={<News />} />
            <Route path="/community" element={<Community />} />
            <Route path="/hall-of-fame" element={<HallOfFame />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/auth/callback" element={<SocialPulseCallback />} />
            <Route path="/moderation" element={<Moderation />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
